var FontIcons;
(function (FontIcons) {
  FontIcons["AddPage"] = 'add-page';
  FontIcons["Alert"] = 'alert';
  FontIcons["AlertFilled"] = 'alert-filled';
  FontIcons["Approve"] = 'approve';
  FontIcons["ArrowDown"] = 'arrow-down';
  FontIcons["ArrowDownUp"] = 'arrow-down-up';
  FontIcons["ArrowLeft"] = 'arrow-left';
  FontIcons["ArrowRight"] = 'arrow-right';
  FontIcons["ArrowUp"] = 'arrow-up';
  FontIcons["ArrowUpDown"] = 'arrow-up-down';
  FontIcons["Attention"] = 'attention';
  FontIcons["BarGraph"] = 'bar-graph';
  FontIcons["Boards"] = 'boards';
  FontIcons["BrandCollective"] = 'brand-collective';
  FontIcons["BrandGuide"] = 'brand-guide';
  FontIcons["BrandguideV2"] = 'brandguide-v2';
  FontIcons["Build"] = 'build';
  FontIcons["Calendar"] = 'calendar';
  FontIcons["Canva"] = 'canva';
  FontIcons["Canvas"] = 'canvas';
  FontIcons["CaretDown"] = 'caret-down';
  FontIcons["CaretLeft"] = 'caret-left';
  FontIcons["CaretLeftDouble"] = 'caret-left-double';
  FontIcons["CaretRight"] = 'caret-right';
  FontIcons["CaretRightDouble"] = 'caret-right-double';
  FontIcons["CaretUp"] = 'caret-up';
  FontIcons["Chat"] = 'chat';
  FontIcons["CheckCircleFilled"] = 'check-circle-filled';
  FontIcons["CheckIn"] = 'check-in';
  FontIcons["CheckMark"] = 'check-mark';
  FontIcons["CheckMarkCircle"] = 'check-mark-circle';
  FontIcons["CheckOut"] = 'check-out';
  FontIcons["Clock"] = 'clock';
  FontIcons["Close"] = 'close';
  FontIcons["CloudDownload"] = 'cloud-download';
  FontIcons["ColorHexa"] = 'color-hexa';
  FontIcons["Columns"] = 'columns';
  FontIcons["Comment"] = 'comment';
  FontIcons["Confirmation"] = 'confirmation';
  FontIcons["Connector"] = 'connector';
  FontIcons["Copy"] = 'copy';
  FontIcons["CreditCard"] = 'credit-card';
  FontIcons["Crop"] = 'crop';
  FontIcons["Cursor"] = 'cursor';
  FontIcons["CustomField"] = 'custom-fields';
  FontIcons["DollarSign"] = 'dollar-sign';
  FontIcons["Download"] = 'download';
  FontIcons["Draft"] = 'draft';
  FontIcons["DragIndicator"] = 'drag-indicator';
  FontIcons["Edit"] = 'edit';
  FontIcons["Ellipsis"] = 'ellipsis';
  FontIcons["Email"] = 'email';
  FontIcons["Embed"] = 'embed';
  FontIcons["Enter"] = 'enter';
  FontIcons["FaceHappy"] = 'face-happy';
  FontIcons["FaceSad"] = 'face-sad';
  FontIcons["FacebookIcon"] = 'facebook-icon';
  FontIcons["FacebookIconSquare"] = 'facebook-icon-square';
  FontIcons["Filters"] = 'filters';
  FontIcons["FontType"] = 'font-type';
  FontIcons["Form"] = 'form';
  FontIcons["FullScreen"] = 'full-screen';
  FontIcons["GeneralSettings"] = 'general-settings';
  FontIcons["GridView"] = 'grid-view';
  FontIcons["Hide"] = 'hide';
  FontIcons["HorizontalOrientation"] = 'horizontal-orientation';
  FontIcons["Image"] = 'image';
  FontIcons["Info"] = 'info';
  FontIcons["Ingest"] = 'ingest';
  FontIcons["Insights"] = 'insights';
  FontIcons["Instagram"] = 'instagram';
  FontIcons["Integrations"] = 'integrations';
  FontIcons["KnowledgeBase"] = 'knowledge-base';
  FontIcons["Label"] = 'label';
  FontIcons["Language"] = 'language';
  FontIcons["LightbulbFilled"] = 'lightbulb-filled';
  FontIcons["Link"] = 'link';
  FontIcons["LinkedIn"] = 'linked-in';
  FontIcons["LinkedinIconSquare"] = 'linkedin-icon-square';
  FontIcons["ListView"] = 'list-view';
  FontIcons["LocationMarker"] = 'location-marker';
  FontIcons["Logo"] = 'logo';
  FontIcons["ManageSubscription"] = 'manage-subscription';
  FontIcons["ManageVersion"] = 'manage-versions';
  FontIcons["Menu"] = 'menu';
  FontIcons["Merge"] = 'merge';
  FontIcons["Metadata"] = 'metadata';
  FontIcons["Monitor"] = 'monitor';
  FontIcons["Move"] = 'move';
  FontIcons["NewTab"] = 'new-tab';
  FontIcons["NotificationSettings"] = 'notification-settings';
  FontIcons["Notifications"] = 'notifications';
  FontIcons["Organization"] = 'organization';
  FontIcons["Palette"] = 'palette';
  FontIcons["PanoramicOrientation"] = 'panoramic-orientation';
  FontIcons["Paperclip"] = 'paperclip';
  FontIcons["Payment"] = 'payment';
  FontIcons["People"] = 'people';
  FontIcons["Person"] = 'person';
  FontIcons["Phone"] = 'phone';
  FontIcons["Pin"] = 'pin';
  FontIcons["Pinterest"] = 'pinterest';
  FontIcons["Plus"] = 'plus';
  FontIcons["Portal"] = 'portal';
  FontIcons["PressRelease"] = 'press-release';
  FontIcons["Print"] = 'print';
  FontIcons["PriorityHigh"] = 'priority-high';
  FontIcons["PriorityMedium"] = 'priority-medium';
  FontIcons["Private"] = 'private';
  FontIcons["Public"] = 'public';
  FontIcons["QuoteEnd"] = 'quote-end';
  FontIcons["QuoteStart"] = 'quote-start';
  FontIcons["RatioLock"] = 'ratio-lock';
  FontIcons["Refresh"] = 'refresh';
  FontIcons["RefreshSpinning"] = 'refresh-spinning';
  FontIcons["Remove"] = 'remove';
  FontIcons["Reorder"] = 'reorder';
  FontIcons["Reports"] = 'reports';
  FontIcons["RequestDownload"] = 'request-download';
  FontIcons["RulesEngine"] = 'rules-engine';
  FontIcons["Save"] = 'save';
  FontIcons["ScoreMeter"] = 'score-meter';
  FontIcons["Search"] = 'search';
  FontIcons["Section"] = 'section';
  FontIcons["Sent"] = 'sent';
  FontIcons["Settings"] = 'settings';
  FontIcons["Share"] = 'share';
  FontIcons["Show"] = 'show';
  FontIcons["Smartsheet"] = 'smartsheet';
  FontIcons["SparkleFilled"] = 'sparkle-filled';
  FontIcons[/** @deprecated Use `<CircleLoader>` instead */"SpinnerGif"] = 'spinner-gif';
  FontIcons["SquareOrientation"] = 'square-orientation';
  FontIcons["Star"] = 'star';
  FontIcons["StarHollow"] = 'star-hollow';
  FontIcons["Stealth"] = 'stealth';
  FontIcons["Switch"] = 'switch';
  FontIcons["Tag"] = 'tag';
  FontIcons["Task"] = 'task';
  FontIcons["Template"] = 'template';
  FontIcons["TemplateEditor"] = 'template-editor';
  FontIcons["Tip"] = 'tip';
  FontIcons["ToolTip"] = 'tool-tip';
  FontIcons["Trash"] = 'trash';
  FontIcons["TwitterIcon"] = 'twitter-icon';
  FontIcons["Unapprove"] = 'unapprove';
  FontIcons["Unlink"] = 'unlink';
  FontIcons["Upload"] = 'upload';
  FontIcons["UserAccepted"] = 'user-accepted';
  FontIcons["UserCollaborator"] = 'user-collaborator';
  FontIcons["UserFilled"] = 'user-filled';
  FontIcons["UserGuest"] = 'user-guest';
  FontIcons["UserInvited"] = 'user-invited';
  FontIcons["UserSettings"] = 'user-settings';
  FontIcons["VerticalOrientation"] = 'vertical-orientation';
  FontIcons["Video"] = 'video';
  FontIcons["VisitMedia"] = 'visit-media';
  FontIcons["Warning"] = 'warning';
  FontIcons["Watermark"] = 'watermark';
  FontIcons["Workspace"] = 'workspace';
  FontIcons["XCirlce"] = 'x-circle';
  FontIcons["YouTubeIcon"] = 'you-tube-icon';
  FontIcons["ZipFile"] = 'zip-file';
  FontIcons["ZoomIn"] = 'zoom-in';
  FontIcons["ZoomOut"] = 'zoom-out';
})(FontIcons || (FontIcons = {}));
var FontIconColors;
(function (FontIconColors) {
  FontIconColors["None"] = '';
  FontIconColors["Danger"] = 'danger';
  FontIconColors["Primary"] = 'primary';
  FontIconColors["Text"] = 'text';
  FontIconColors["Warning"] = 'warning';
  FontIconColors["White"] = 'white';
})(FontIconColors || (FontIconColors = {}));
var FontIconPositions;
(function (FontIconPositions) {
  FontIconPositions["None"] = '';
  FontIconPositions["Left"] = 'left';
  FontIconPositions["Right"] = 'right';
})(FontIconPositions || (FontIconPositions = {}));
export { FontIconColors, FontIconPositions, FontIcons };